<style lang="scss">
@import '~scss/_variables';

@for $i from 1 through 3 {
    $max-offset: 3 * $grid-size;
    $offset: ($i - 1) * $grid-size;
    $reverse-offset: $max-offset - $offset;
    $margin-offset: $reverse-offset - $grid-size;

    .step-#{$i} {
        width: 100%;
        margin-top: $offset;
        box-sizing: content-box;
        top: 0px;
        left: 100%;

        &.is-pulled {
            left: -$step-border-width;
        }

        @include media-larger('sm') {
            width: calc(100% - #{$offset});
            box-sizing: border-box;
            left: calc(100% - #{$reverse-offset});

            &.is-pulled {
                left: $offset;
            }

            .step-content {
                margin-right: $margin-offset;
            }
        }
    }
}

.step {
    height: 100%;
    padding: 0.1px 0;
    position: absolute;

    background: $color-accent-1;
    border-top: $step-border-width solid $color-border-1;
    border-left: $step-border-width solid $color-border-1;
    transition: left $transition-step;

    &.is-active {
        height: auto;
        position: relative;

        .step-id-small {
            top: 40px;
            left: 40px;
            color: transparent;

            &:after {
                transform: scale(1);
                opacity: 1;
            }
        }
    }

    &.is-clickable {
        cursor: pointer;
    }

    .step-fade-enter,
    .step-fade-leave-to {
        opacity: 0;
    }

    .step-fade-enter-active,
    .step-fade-leave-active {
        transition: opacity $transition-step-content-fade;
    }
}

.step-pad {
    padding-left: #{$grid-size * 2};
    padding-right: #{$grid-size * 2};
}

    .step-id-small {
        position: absolute;
            top: 14px;
            left: 14px;

        font-family: $font-family-2;
        font-size: 16px;
        color: $color-text-1;
        line-height: 1;

        user-select: none;
        transition:
            color 0.8s ease,
            top 0.6s $easing-easeInOutCubic,
            left 0.65s $easing-easeInOutCubic;

        &:after {
            $circle-size: 20px;

            content: '';
            width: $circle-size;
            height: $circle-size;
            margin-top: -#{$circle-size / 2};
            margin-left: -#{$circle-size / 2};
            position: absolute;
                top: 50%;
                left: 50%;

            background: $color-text-2;
            border-radius: 50%;

            transform: scale(0);
            opacity: 0;
            transition:
                opacity $transition-step-circle,
                transform $transition-step-circle;
        }
    }

    .step-title {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-top: #{$grid-size * 2};
        margin-bottom: 0;

        font-size: 16px;
        font-family: $font-family-2;
        color: $color-white;
        user-select: none;
    }

        .step-id-large {
            margin-top: -0.48em;
            margin-left: -0.065em;
            font-size: 12.5em;
            font-weight: bold;
            user-select: none;
            pointer-events: none;
        }

        .step-title-text {
            margin-left: 42px;
            font-weight: normal;

            .subtitle {
                display: block;
                margin-bottom: 1.2em;
                padding-left: 120px;

                color: $color-text-2;
                font-size: 16px;
                font-family: $font-family-1;
                line-height: 1.2;
                letter-spacing: -0.7px;
                text-align: left;
            }

            .title {
                display: block;
                font-size: 9em;
                font-weight: lighter;
                line-height: 0.67em;
                text-transform: uppercase;
            }
        }

    .step-content {
        max-width: #{960px + ($grid-size * 2) * 2};
    }

        .step-btn-next {
            display: block;
            width: 160px;
            height: 160px;
            margin: 32px auto $grid-size auto;
            position: relative;

            font-family: $font-family-2;
            font-size: 32px;
            font-weight: bold;
            text-transform: uppercase;
            color: $color-white;

            user-select: none;

            &:before {
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                    top: 0;
                    left: 0;

                background: $color-background-1;
                border-radius: 50%;

                transform: scale(1);
                transition:
                    transform $transition-next-step-button,
                    background $transition-2,
                    opacity $transition-2;
            }

            &:hover {
                &:before {
                    transform: scale(1.06);
                }
            }

            &:active {
                &:before {
                    transform: scale(1.1);
                }
            }

            &:focus {
                outline: none;

                &:before {
                    background: lighten($color-background-1, 4);
                }
            }

            &[disabled] {
                cursor: not-allowed;

                &:before {
                    opacity: 0.7;
                    transform: none;
                }
            }

            span {
                position: relative;
            }
        }

@include media-smaller('lg') {
    .step-title {
        font-size: 8px;
    }

        .step-title-text {
            margin-left: 20px;

            .subtitle {
                padding-left: 0;

                br {
                    display: none;
                }
            }

            .title {
                margin-left: -0.05em;
            }
        }
}

@include media-smaller('md') {
    .step {
        &.is-active {
            .step-id-small {
                top: $mobile-pad;
                left: $mobile-pad;
            }
        }
    }

        .step-title {
            justify-content: center;
        }

        .step-pad {
            padding-left: $mobile-pad;
            padding-right: $mobile-pad;
        }

        .step-id-small {
            top: 11px;
            left: $mobile-pad;
        }
}

@include media-smaller('sm') {
    .step-title {
        font-size: 6px;
    }

        .step-title-text {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;

            .title {
                font-size: 7em;
            }

            .subtitle {
                margin-bottom: 10px;
                font-size: 18px;
            }
        }
}
</style>

<template>
    <div
        @click="handleClick"
        :class="{
            'step': true,
            'is-active': isActive,
            'is-pulled': isPulled,
            'is-clickable': canGoBack,
            ['step-' + stepNumber]: true
        }"
    >
        <small class="step-id-small">{{ stepNumber }}.</small>

        <h2 class="step-title step-pad">
            <span class="step-id-large">{{ stepNumber }}</span>

            <div class="step-title-text">
                <span class="subtitle"><slot name="subtitle"></slot></span>
                <span class="title"><slot name="title"></slot></span>
            </div>
        </h2>

        <transition name="step-fade">
            <slot v-if="!initiallyHidden"></slot>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['index', 'activeIndex'],
    data () {
        return {
            initiallyHidden: true
        };
    },
    computed: {
        canProceed: () => true,
        stepNumber () {
            return this.index + 1;
        },
        isActive () {
            return this.index === this.activeIndex;
        },
        isPulled () {
            return this.isActive || (this.index < this.activeIndex);
        },
        canGoBack () {
            return !this.isActive && this.isPulled;
        }
    },
    methods: {
        proceed () {
            if (this.canProceed) {
                this.$emit('completed', this.getFormData());

                gtag('event', 'completed_step', {
                    'event_label': 'Step ' + this.stepNumber,
                    'event_category': 'journey'
                });
            }
        },
        handleClick () {
            if (this.canGoBack) {
                this.$emit('set-active', this.index);
            }
        },
        getFormData () {
            return {};
        }
    },
    watch: {
        isActive: {
            immediate: true,
            handler (newValue) {
                if (newValue === true) {
                    this.initiallyHidden = false;
                }
            }
        }
    }
};
</script>
